(function ($) {
    if ($('.projects-map #map').length) {
        let projectsMap;
        const infoWindows = [];
        const poiMarkers = [];
        const projectMarkers = [];
        const poiMarkerIconClosed = {url: liven.template_directory + "/assets/images/map-marker-round.svg"};
        const poiMarkerIconOpen = {url: liven.template_directory + "/assets/images/map-marker-round-red.svg"};
        const projectMarkerIconClosed = {url: liven.template_directory + "/assets/images/map-project-marker.svg"};
        const projectMarkerIconOpen = {url: liven.template_directory + "/assets/images/map-project-marker-red.svg"};

        function ZoomControl(controlDiv, map) {
            controlDiv.setAttribute('class', 'zoom-controls');

            const zoomInButton = document.createElement('div');
            zoomInButton.setAttribute('class', 'zoom-button zoom-in');
            controlDiv.appendChild(zoomInButton);

            const zoomOutButton = document.createElement('div');
            zoomOutButton.setAttribute('class', 'zoom-button zoom-out');
            controlDiv.appendChild(zoomOutButton);

            zoomInButton.addEventListener('click', function () {
                projectsMap.setZoom(projectsMap.getZoom() + 1);
            });

            zoomOutButton.addEventListener('click', function () {
                projectsMap.setZoom(projectsMap.getZoom() - 1);
            });
        }

        function closeAllInfoWindows() {
            for (let infoWindow of infoWindows) {
                infoWindow.close();
            }
        }

        function resetPoiMarkerIcons() {
            for (let marker of poiMarkers) {
                marker.setIcon(poiMarkerIconClosed);
            }
        }

        function resetProjectMarkerIcons() {
            for (let marker of projectMarkers) {
                marker.setIcon(projectMarkerIconClosed);
            }
        }

        function initProjectsMap() {
            const styledMapType = new google.maps.StyledMapType(
                [
                    {
                        "featureType": "administrative",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#545B5C"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape",
                        "elementType": "all",
                        "stylers": [
                            {
                                "color": "#F2F2F2"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#FFFFFF"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#E6F3D6"
                            },
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "all",
                        "stylers": [
                            {
                                "saturation": -100
                            },
                            {
                                "lightness": 45
                            },
                            {
                                "visibility": "simplified"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "simplified"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#E6E8EC"
                            },
                            {
                                "visibility": "simplified"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "labels.text",
                        "stylers": [
                            {
                                "color": "#4E4E4E"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#E6E8EC"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#787878"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#E6E8EC"
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "labels.text",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#6C6C6C"
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "labels.text.stroke",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "transit",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "all",
                        "stylers": [
                            {
                                "color": "#EAF6F8"
                            },
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#EDF4FF"
                            }
                        ]
                    }
                ],
                { name: "Styled Map" }
            );

            projectsMap = new google.maps.Map(document.getElementById("map"), {
                center: {lat: 59.44, lng: 24.73},
                zoom: 12,
                disableDefaultUI: true,
            });

            projectsMap.mapTypes.set("styled_map", styledMapType);
            projectsMap.setMapTypeId("styled_map");

            // Custom zoom controls

            const zoomControlDiv = document.createElement('div');
            const zoomControl = new ZoomControl(zoomControlDiv, map);

            zoomControlDiv.index = 1;
            projectsMap.controls[google.maps.ControlPosition.BOTTOM_RIGHT].push(zoomControlDiv);

            // Markers and infoWindows

            for (let project of mapProjects) {
                const infoWindow = new google.maps.InfoWindow({
                    content:
                        `<div class="popup">
                            <p>${project.title}</p>
                        </div>`,
                });

                infoWindows.push(infoWindow);

                const marker = new google.maps.Marker({
                    position: { lat: parseFloat(project.location.lat), lng: parseFloat(project.location.lng) },
                    icon: projectMarkerIconClosed,
                    map: projectsMap,
                    link: project.link,
                    target: project.target,
                    category: project.id,
                });
                projectMarkers.push(marker);

                marker.addListener("click", () => {
                    closeAllInfoWindows();
                    resetProjectMarkerIcons();
                    resetPoiMarkerIcons();


                    infoWindow.open({
                        anchor: marker,
                        projectsMap,
                        shouldFocus: false,
                    });

                    window.open(project.link, project.target);

                    marker.setIcon(projectMarkerIconOpen);
                });

                marker.addListener("mouseover", () => {
                    closeAllInfoWindows();
                    resetProjectMarkerIcons();
                    resetPoiMarkerIcons();

                    infoWindow.open({
                        anchor: marker,
                        projectsMap,
                        shouldFocus: false,
                    });

                    marker.setIcon(projectMarkerIconOpen);
                });

                marker.addListener("mouseout", () => {
                    closeAllInfoWindows();
                    resetProjectMarkerIcons();
                    resetPoiMarkerIcons();
                });
            }

            // for (let poi of mapProjects) {
            // //     const infoWindow = new google.maps.InfoWindow({
            // //         content:
            // //             `<div class="popup">
            // //                 <p>${poi.popup_text}</p>
            // //             </div>`,
            // //     });
            // //
            // //     infoWindows.push(infoWindow);
            // //
            //         console.log(poi);
            //     const marker = new google.maps.Marker({
            //         position: { lat: poi.location.lat, lng: poi.location.lng },
            //         // icon: poiMarkerIconClosed,
            //         map: projectsMap,
            //         category: poi.id,
            //     });
            // //
            //     projectMarkers.push(marker);
            // //
            // //     marker.addListener("click", () => {
            // //         closeAllInfoWindows();
            // //         resetProjectMarkerIcons();
            // //         resetPoiMarkerIcons();
            // //
            // //         infoWindow.open({
            // //             anchor: marker,
            // //             projectsMap,
            // //             shouldFocus: false,
            // //         });
            // //
            // //         marker.setIcon(poiMarkerIconOpen);
            // //     });
            // //
            // //     marker.addListener("mouseover", () => {
            // //         closeAllInfoWindows();
            // //         resetProjectMarkerIcons();
            // //         resetPoiMarkerIcons();
            // //
            // //         infoWindow.open({
            // //             anchor: marker,
            // //             projectsMap,
            // //             shouldFocus: false,
            // //         });
            // //
            // //         marker.setIcon(poiMarkerIconOpen);
            // //     });
            // //
            // //     marker.addListener("mouseout", () => {
            // //         closeAllInfoWindows();
            // //         resetProjectMarkerIcons();
            // //         resetPoiMarkerIcons();
            // //     });
            // }

            projectsMap.addListener('click', function (event) {
                if (event.placeId) {
                    event.stop();
                } else {
                    closeAllInfoWindows();
                    resetPoiMarkerIcons();
                    resetProjectMarkerIcons();
                }
            });
        }

        window.initProjectsMap = initProjectsMap;

        let googleMapLoaded = false;
        window.addEventListener('scroll', function(){
            if (googleMapLoaded === false && window.scrollY > document.querySelector('#map').getBoundingClientRect().top - window.innerHeight) {
                googleMapLoaded = true;
                const script = document.createElement('script');
                script.type = 'text/javascript';
                script.src = '//maps.googleapis.com/maps/api/js?key=AIzaSyApjjTyrFhnGSdWTxB060QTxK1NqVJ0ZTo&callback=initProjectsMap';
                document.body.appendChild(script);
            }
        });

        $('.map-categories li').on('click', function () {
            if ($(this).hasClass('active')) return;

            const category = $(this).data('category');
            $(this).addClass('active').siblings().removeClass('active');


            closeAllInfoWindows();
            resetPoiMarkerIcons();
            resetProjectMarkerIcons();
            var bounds = new google.maps.LatLngBounds();
            if (category === "all") {
                projectMarkers.forEach((marker, index) => {
                    marker.setVisible(true)
                    bounds.extend( marker.getPosition() );
                    projectsMap.fitBounds(bounds);
                })
            } else {
                projectMarkers.forEach((marker, index) => {
                    if (marker.category === category) {
                        marker.setVisible(true)
                        bounds.extend( marker.getPosition() );
                        projectsMap.fitBounds(bounds);
                    } else {
                        marker.setVisible(false)
                    }
                })
            }
        })

        $('.map-categories-mobile .header').on('click', function () {
            const parent = $(this).closest('.map-categories-mobile');
            const nav = parent.find('ul');

            parent.toggleClass('active');
            nav.slideToggle();
        })

        $('.map-categories-mobile li').on('click', function () {
            if ($(this).hasClass('active')) return;

            const category = $(this).data('category');
            const parent = $(this).closest('.map-categories-mobile');
            const tabName = $(this).text();
            const nav = $(parent).find('ul');
            const status = $(this).data('status');

            $(this).addClass('active').siblings().removeClass('active');
            parent.toggleClass('active');
            nav.slideToggle();
            parent.find('.header p').text(tabName);


            closeAllInfoWindows();
            resetPoiMarkerIcons();
            resetProjectMarkerIcons();

            var bounds = new google.maps.LatLngBounds();
            if (category === "all") {
                projectMarkers.forEach((marker, index) => {
                    marker.setVisible(true)
                    bounds.extend( marker.getPosition() );
                    projectsMap.fitBounds(bounds);
                })
            } else {
                projectMarkers.forEach((marker, index) => {
                    if (marker.category === category) {
                        marker.setVisible(true)
                        bounds.extend( marker.getPosition() );
                        projectsMap.fitBounds(bounds);
                    } else {
                        marker.setVisible(false)
                    }
                })
            }
        })
    }
})(jQuery);